<template>
    <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-btn slot="activator" color="secondary" class="text--primary">Import offers</v-btn>
        <v-card>
            <form v-on:submit.prevent="create">
                <v-card-title>
                    <span class="headline">Import offers</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 s12 md12 class="">
                                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="subido"></vue-dropzone>
                            </v-flex>
                            <hr>
                            <v-flex xs12 v-if="response">
                                <h4>Offers created: {{ response.offers_created }}</h4>
                                <h4>Errors: {{ response.errors_count }}</h4>
                                <hr v-if="response.errors.length > 0">
                                <div v-for="error in response.errors">
                                    <ul>
                                        <li>{{ error.message }}</li>
                                        <li v-for="err in error.errors">{{ err[0] }}</li>
                                    </ul>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat type="submit">Import</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { API_BASE } from '../../../config';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        data: () => ({
            dialog: false,
            dropzoneOptions: {
                url: API_BASE + 'offers/import',
                thumbnailWidth: 150,
                maxFilesize: 500,
                headers: { 'Authorization' : localStorage.getItem('token'),
                    'Autrollization' : localStorage.getItem('token'),
                    'Authorization-temp' : localStorage.getItem('token')
                },
                addRemoveLinks: true,
            },
            response: null
        }),
        created () {
        },
        mounted () {
        },
        methods: {
            create () {

            },
            cancel () {
                this.dialog = false;
            },
            subido (file, response) {
                this.response = response;
                this.$emit('importado');
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/oferta/components/ImportModalComponent.vue